// Module
var code = "<div class=\"markup-width-selector dropdown\"> <div ng-repeat=\"size in vm.sizeList\" class=\"markup-width-selector dropdown__option\" ng-class=\"{\n      'dropdown__option--selected': $index == vm.currentlySelectedIndex\n    }\" ng-click=\"vm.selectSize($index)\"> <div class=\"{{ vm.getSizeClass($index) }}\">&nbsp;</div> </div> </div> ";
// Exports
module.exports = code;